import { render, staticRenderFns } from "./website-rating-model.vue?vue&type=template&id=2557740e&scoped=true&"
import script from "./website-rating-model.vue?vue&type=script&lang=js&"
export * from "./website-rating-model.vue?vue&type=script&lang=js&"
import style0 from "./website-rating-model.vue?vue&type=style&index=0&id=2557740e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2557740e",
  null
  
)

export default component.exports